import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(() => ({
  root: {
    '& .MuiPaper-root': {
      maxWidth: 420,
      width: '100%',
      minHeight: 0,
    },
  },
  content: {
    alignItems: 'stretch !important',
    gap: '12px !important',
    padding: '2px 20px 20px !important',
  },
  description: {
    textAlign: 'left',
    margin: 0,
  },
  radioGroup: {
    alignItems: 'flex-start',
  },
  radioOption: {
    marginLeft: 0,
  },
  alert: {
    marginTop: 8,
  },
}))
